import { Box, Typography, useTheme } from '../../../../../../base';
import { StyledOptionsContainer } from '../../JobQuestions.styles';
import { useTranslation } from 'react-i18next';

export const QuestionTextEditor = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <StyledOptionsContainer>
            <Box
                sx={{
                    width: '100%',
                    minHeight: '120px',
                    padding: theme.spacing(2),
                    backgroundColor: theme.palette.grey[100],
                    borderRadius: theme.spacing(1),
                    border: `1px solid ${theme.palette.grey[300]}`,
                    cursor: 'not-allowed',
                    opacity: 0.7,
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        color: theme.palette.text.disabled,
                        fontStyle: 'italic',
                    }}
                >
                    {t('saveJob.longTextPlaceholder')}
                </Typography>
            </Box>
        </StyledOptionsContainer>
    );
};
